import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { SkillGroup, SkillAvailableCurator } from '../models/skill-learning.model';
import { SKILL_GROUPS_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillGroupApiService {

  constructor(private http: Http) {}

  fetchAllGroups(): Observable<SkillGroup[]> {
    return this.http
      .get(SKILL_GROUPS_API.BASE)
      .map(response => response.json() as SkillGroup[]);
  }

  fetchGroupById(groupId: string): Observable<SkillGroup> {
    return this.http
      .get(SKILL_GROUPS_API.BY_ID(groupId))
      .map(response => response.json() as SkillGroup);
  }

  fetchGroupUsers(groupId: string): Observable<SkillAvailableCurator[]> {
    return this.http
      .get(SKILL_GROUPS_API.GROUP_USERS(groupId))
      .map(response => response.json() as SkillAvailableCurator[]);
  }

  fetchAvailableCurators(groupId: string, specializationId: string): Observable<SkillAvailableCurator[]> {
    return this.http
      .get(SKILL_GROUPS_API.AVAILABLE_CURATORS(groupId, specializationId))
      .map(response => response.json() as SkillAvailableCurator[]);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-group-api.service.ts